var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvested(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0007,
    cy: 10.0007,
    r: 6.66667,
    fill: "#1177BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4994 36.6667C24.7495 36.6667 23.3746 36.6667 22.5203 35.8124C21.666 34.9581 21.666 33.5832 21.666 30.8333C21.666 28.0835 21.666 26.7085 22.5203 25.8543C23.3746 25 24.7495 25 27.4994 25C30.2492 25 31.6241 25 32.4784 25.8543C33.3327 26.7085 33.3327 28.0835 33.3327 30.8333C33.3327 33.5832 33.3327 34.9581 32.4784 35.8124C31.6241 36.6667 30.2492 36.6667 27.4994 36.6667ZM30.7794 29.5764C31.1591 29.1967 31.1591 28.5811 30.7794 28.2014C30.3997 27.8217 29.7842 27.8217 29.4045 28.2014L26.2031 31.4028L25.5942 30.794C25.2145 30.4143 24.599 30.4143 24.2193 30.794C23.8396 31.1737 23.8396 31.7893 24.2193 32.1689L25.5156 33.4652C25.8953 33.8449 26.5108 33.8449 26.8905 33.4652L30.7794 29.5764Z",
    fill: "#1177BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1586 25.0513C29.4505 24.9993 28.5819 24.9993 27.5007 24.9993C24.7508 24.9993 23.3759 24.9993 22.5216 25.8536C21.6673 26.7079 21.6673 28.0828 21.6673 30.8327C21.6673 32.7765 21.6673 34.0333 21.9691 34.9049C21.3292 34.967 20.6715 34.9993 20.0007 34.9993C13.5573 34.9993 8.33398 32.0146 8.33398 28.3327C8.33398 24.6508 13.5573 21.666 20.0007 21.666C24.3564 21.666 28.1546 23.03 30.1586 25.0513Z",
    fill: "#84DCC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvested);
export default __webpack_public_path__ + "static/media/invested.f37873b8b1edbd8aa837848bfe25f376.svg";
export { ForwardRef as ReactComponent };